var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMResumenAnual(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#2eccb6;}.cls-3{fill:#329be6;}.cls-4{fill:#0b5c96;}.cls-5{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m_resumen_anual"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "54.75 46.5 57.5 46.5 57.5 41.5 54.75 44.25 54.75 46.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "13.5 46.5 8.5 41.5 8.5 46.5 13.5 46.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.25,59.45v-4.6H25a3.75,3.75,0,0,1-3.75-3.75V49H16L32.72,65.72a.4.4,0,0,0,.56,0l5.87-5.87h-7.5A.4.4,0,0,1,31.25,59.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26,8.4v6H40v-6a.4.4,0,0,1,.4-.4H41L33.28.28a.4.4,0,0,0-.56,0L25,8h.6A.4.4,0,0,1,26,8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M.28,32.72a.4.4,0,0,0,0,.56L6,39V27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.72,32.72,60,27V39l5.72-5.72A.4.4,0,0,0,65.72,32.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.25,46.5V30.34a.4.4,0,0,1,.4-.4h1.7a.4.4,0,0,1,.4.4V51.1a1.25,1.25,0,0,0,2.5,0V36.5A3.75,3.75,0,0,1,30,32.75H42.25V30.4a.4.4,0,0,1,.4-.4h1.7a.4.4,0,0,1,.4.4v2.35H51a3.75,3.75,0,0,1,3.75,3.75v7.75L57.5,41.5V25H8.5V41.5l5,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M60,14.85a.4.4,0,0,0-.4-.4H48v-6a.4.4,0,0,0-.4-.4H41L60,27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.41,8a.4.4,0,0,0-.4.4v6H6.4a.4.4,0,0,0-.4.4V27L25,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M8.5,46.5v-5L6,39v9.6a.4.4,0,0,0,.4.4H16l-2.5-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M57.5,46.5H54.75V44.25l-15.6,15.6h15.2a.4.4,0,0,0,.4-.4V49H59.6a.4.4,0,0,0,.4-.4V39l-2.5,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M54.75,36.5A3.75,3.75,0,0,0,51,32.75H44.75V30.4a.4.4,0,0,0-.4-.4h-1.7a.4.4,0,0,0-.4.4v2.35H30a3.75,3.75,0,0,0-3.75,3.75V51.1a1.25,1.25,0,0,1-2.5,0V30.34a.4.4,0,0,0-.4-.4h-1.7a.4.4,0,0,0-.4.4V46.5H13.5L16,49h5.25v2.1A3.75,3.75,0,0,0,25,54.85h6.25v4.6a.4.4,0,0,0,.4.4h7.5l15.6-15.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M41,8h-.59a.4.4,0,0,0-.4.4v6H26v-6a.4.4,0,0,0-.4-.4H25L6,27V39l2.5,2.5V25h49V41.5L60,39V27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M28.52,52.35a3.7,3.7,0,0,0,.23-1.25V36.5a1.25,1.25,0,0,1,2.5,0V52.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M51,35.25H33.54a4,4,0,0,1,.21,1.25V57.35h18.5V36.5A1.25,1.25,0,0,0,51,35.25ZM44.5,52.66v1.68a.67.67,0,0,1-.67.65h-2a.65.65,0,0,1-.65-.65V52.89a7.65,7.65,0,0,1-1.81-.52,1,1,0,0,1-.6-1.16l.17-.65a1,1,0,0,1,.52-.65,1.05,1.05,0,0,1,.78,0,5.73,5.73,0,0,0,2.24.43c.34,0,1.46-.05,1.46-.85,0-.45-.14-.79-1.73-1.33s-3.4-1.29-3.4-3.53a3.61,3.61,0,0,1,2.42-3.38V39.68a.65.65,0,0,1,.18-.47.6.6,0,0,1,.47-.2h2a.65.65,0,0,1,.65.65v1.41A4.16,4.16,0,0,1,46,41.4a1,1,0,0,1,.6,1.17l-.13.67a1.12,1.12,0,0,1-.52.63.85.85,0,0,1-.76,0,5.31,5.31,0,0,0-1.77-.3c-.82,0-1.29.36-1.29.77s.51.73,2,1.29c2.22.79,3.16,1.86,3.16,3.65A4.26,4.26,0,0,1,44.5,52.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.08,45.63c-1.48-.56-2-.89-2-1.29s.47-.77,1.29-.77a5.31,5.31,0,0,1,1.77.3.85.85,0,0,0,.76,0,1.12,1.12,0,0,0,.52-.63l.13-.67A1,1,0,0,0,46,41.4a4.16,4.16,0,0,0-1.39-.33V39.66a.65.65,0,0,0-.65-.65h-2a.6.6,0,0,0-.47.2.65.65,0,0,0-.18.47v1.57a3.61,3.61,0,0,0-2.42,3.38c0,2.24,1.81,3,3.4,3.53S44,49,44,49.49c0,.8-1.12.85-1.46.85a5.73,5.73,0,0,1-2.24-.43,1.05,1.05,0,0,0-.78,0,1,1,0,0,0-.52.65l-.17.65a1,1,0,0,0,.6,1.16,7.65,7.65,0,0,0,1.81.52v1.45a.65.65,0,0,0,.65.65h2a.67.67,0,0,0,.67-.65V52.66a4.26,4.26,0,0,0,2.74-3.38C47.24,47.49,46.3,46.42,44.08,45.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M54.75,46.5v-10A3.75,3.75,0,0,0,51,32.75H44.75V30.4a.4.4,0,0,0-.4-.4h-1.7a.4.4,0,0,0-.4.4v2.35H30a3.75,3.75,0,0,0-3.75,3.75V51.1a1.25,1.25,0,0,1-2.5,0V30.34a.4.4,0,0,0-.4-.4h-1.7a.4.4,0,0,0-.4.4V46.5H8.5V25h49V46.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 66,
    height: 66
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMResumenAnual);
export default __webpack_public_path__ + "static/media/m_resumen_anual.b5683b41971ccac6b54f1d2ade60a088.svg";
export { ForwardRef as ReactComponent };